



























































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import UserDTO from "@/dto/UserDTO";
import DesktopMenu from "@/components/main/DesktopMenu.vue";
import MobileMenu from "@/components/main/MobileMenu.vue";
import RouteNames from "@/router/RouteNames";
import SideMenu from "@/components/main/SideMenu.vue";
import Chat from "@/components/support/Chat.vue";
import Notification from "@/components/main/NotificationHolder.vue";
import chat from "@/store/modules/session.module";
import moment from "moment";
import {isPublicPage} from "@/utils/RoutePathUtils";
import AccountService from "@/services/AccountService";

const Auth = namespace("Auth");
const AppModule = namespace("App");

@Component({
  components: { Notification, Chat, SideMenu, MobileMenu, DesktopMenu}
})
export default class MainLayout extends Vue {

  @Auth.Getter
  private isLoggedIn!: boolean;

  @Auth.State("user")
  private currentUser!: UserDTO;

  @Auth.Getter("isAdmin")
  private isAdmin!: boolean;

  @Auth.Getter("hasAdministrativePrivileges")
  private hasAdministrativePrivileges!: boolean;

  @AppModule.State
  private isMobile!: boolean;

  private showMobileMenu = false;

  private routes = RouteNames;

  private currentYear = moment().format("YYYY");

  mounted(): void {
    if (localStorage.getItem("locale")) {
      this.$i18n.locale = localStorage.getItem("locale") || "en";
    }
    chat.setConnection();
  }

  switchLocale(locale: string): void {
    if (this.$i18n.locale !== locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      AccountService.setPreferredLanguage(this.currentUser.id, locale)
    }
  }

  get isInvoiceRoute(): boolean {
    return this.$route.name === RouteNames.INVOICES || this.$route.name === RouteNames.BILLS;
  }

  get isPublicPage(): boolean{
    return !!this.$route.name && isPublicPage(this.$route.name) && this.$route.name != RouteNames.HOME && this.$route.name != RouteNames.LOCATIONS && this.$route.name != RouteNames.PRICES;
  }

  get hasCompanyWorkspace(): boolean {
    const workspaces = this.$wss.getAccessibleWorkspaces();
    return workspaces.some(ws => ws.type === 'COMPANY');
  }

  get hasAdminWorkspace(): boolean {
    return this.$wss.isUserSublimeEmployee;
  }
}
